import api from "./api";

export default class UpdateService {

    static updateParty(param) { return api.put('collect/ccro/update/party',param) }

    static updatePartyPicture(formData) {
        return api.put('collect/ccro/update/party-picture',formData,{headers:{'Content-Type':'multipart/form-data'}}).catch(e=>{console.log(e);})
    }
}